import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { OrderHandoverRosterImportFeaturePage, buildOrderHandoverRouteContext } from "..";

/** 订单交接出行名单导入页路由入口。 */
export function OrderHandoverRosterImportPage() {
  const { projectId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const context = buildOrderHandoverRouteContext(projectId, searchParams);
  const searchText = searchParams.toString();

  /** 返回订单交接详情页，并保留入口查询参数。 */
  function backToDetail() {
    window.close();
    navigate({
      pathname: `/crm/order-handover/${context.projectId}`,
      search: searchText ? `?${searchText}` : "",
    });
  }

  /** 通知原订单交接页刷新名单数据并关闭当前独立工作台。 */
  function notifyRosterImported() {
    if (typeof BroadcastChannel !== "undefined") {
      const channel = new BroadcastChannel("order-handover-roster-import");
      channel.postMessage({
        type: "order-handover-roster-imported",
        projectId: context.projectId,
      });
      channel.close();
    }
    window.close();
  }

  return (
    <OrderHandoverRosterImportFeaturePage
      context={context}
      onBack={backToDetail}
      onImportSuccess={notifyRosterImported}
    />
  );
}
